module.exports = __webpack_public_path__ + "static/media/Mendoza.e5367b8a.svg";